import { createContext } from "react";

export const FundContext = createContext(null);